import { useDispatch } from 'react-redux';
import { notifierShow } from 'components/notifier/actions/show';
import { notifierHide } from 'components/notifier/actions/hide';

var useNotifier = function useNotifier() {
  var dispatch = useDispatch();

  var show = function show(item) {
    return dispatch(notifierShow(item));
  };

  var hide = function hide(id) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return dispatch(notifierHide(id, force));
  };

  return {
    notifierShow: show,
    notifierHide: hide
  };
};

export { useNotifier };